export const REFERRAL_ACTION_OPTIONS = [
  { id: 'polygraphy', cardTitle: 'polygraphy', title: 'Polygraphy' },
  {
    id: 'polysomnography',
    cardTitle: 'polysomnography',
    title: 'Polysomnography',
  },
  { id: 'treatment', cardTitle: 'CPAP treatment', title: 'CPAP treatment' },
];

export const NEXT_CONSULTATION_OPTIONS = [
  { id: 'teleconsultation', title: 'Teleconsultation' },
  { id: 'physical', title: 'Physical' },
];

export const PATIENT_RIGHT_OPTIONS = [
  {
    id: 'required-to-pay-for-consultations-and-examinations',
    title: 'Required to pay for consultations and examinations',
  },
  {
    id: 'required-to-pay-for-consultations-only',
    title: 'Required to pay for consultations only',
  },
  {
    id: 'not-required-to-pay-for-consultations-and-examinations',
    title: 'Not required to pay for consultations and examinations',
  },
];

export const DOCTOR_TYPES = [
  {
    id: 'sleep',
    title: 'Sleep',
  },
  {
    id: 'non-sleep',
    title: 'Non-sleep',
  },
];
